import { render, staticRenderFns } from "./ManagerCollapse.vue?vue&type=template&id=3ddf6412"
import script from "./ManagerCollapse.vue?vue&type=script&lang=ts"
export * from "./ManagerCollapse.vue?vue&type=script&lang=ts"
import style0 from "./ManagerCollapse.vue?vue&type=style&index=0&id=3ddf6412&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ddf6412')) {
      api.createRecord('3ddf6412', component.options)
    } else {
      api.reload('3ddf6412', component.options)
    }
    module.hot.accept("./ManagerCollapse.vue?vue&type=template&id=3ddf6412", function () {
      api.rerender('3ddf6412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/scheduler/ManagerCollapse.vue"
export default component.exports